import React, { Component } from 'react';
import {
  Button, Select, FormControl, TableContainer, Table, TableHead,
  TableBody, TableRow, TableCell, Paper, Dialog, DialogActions, DialogContent,
  InputAdornment,DialogTitle, TextField, Collapse, IconButton, Alert, Box, Typography,TablePagination,InputLabel,MenuItem
} from '@mui/material';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import AddIcon from '@mui/icons-material/Add';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import SearchIcon from '@mui/icons-material/Search';
import searchIcon from './images/SEARCH.png';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default class AdminStaffmanagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      CustData: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 10,searchText: "",     
  searchRole: "",     
  searchStatus: "", 
      itemsPerPageOptions: [10, 20, 30],
    };
    this.staffDialogRef = React.createRef(); 
  }

  componentDidMount() {
	    document.title = "Prep for Sale- Manage staff";
		if(localStorage.getItem("DCuserid")==null)
		  {
		   this.setState({
            logredirect: true,
			pagename:'/'
          })
		  }
    this.fetchCustomer();
  }

fetchCustomer = () => {
  const page = this.state.page;
  const params = {
    excluderole4: 1,
    page,
    limit: this.state.rowsPerPage,
    ...(this.state.searchText && { search: this.state.searchText }),
    ...(this.state.searchRole !== "" && { role: parseInt(this.state.searchRole) }),
    ...(this.state.searchStatus !== "" && { status: this.state.searchStatus }),
  };

  axios.get(Serverurl + "customer/getall", { params })
    .then((res) => {
      const { data, totalItems } = res.data;
      this.setState({ CustData: data, totalItems });
    })
    .catch((error) => {
      console.error('Error fetching data:', error);
    });
};

  CustomerAddbox = (staff = null) => { this.staffDialogRef.current?.handleClickOpen(staff);
};

  toggleActiveStatus = (cu_id, newStatus) => {
    const text = newStatus === 1 ? "Block" : "Unblock";
    confirmAlert({
      title: "Confirm",
      message: `Are you sure you want to ${text} this user?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            axios.put(`${Serverurl}customer/customeractive/${cu_id}`, { cu_isactive: newStatus })
              .then(() => this.fetchCustomer());
          },
        },
        { label: "No" }
      ],
    });
  };

  handleDelete = (cu_id) => {
    confirmAlert({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this user?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            axios.delete(`${Serverurl}customer/customerdelete/${cu_id}`)
              .then(() => this.fetchCustomer());
          }
        },
        { label: "No" },
      ],
    });
  };

handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, this.fetchCustomer);
  };

  handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    this.setState({ rowsPerPage: newRows, page: 0 }, this.fetchCustomer);
  };


  render() {
	  if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
    return (
      <>
	  <div className="maincontentDiv">
        <Box display="flex" justifyContent="space-between" mb={3}>
          <Typography className="contentHeading" variant="h5">Manage Staff</Typography>
          <Button style={{
    marginRight: '20px',
    marginTop: '15px'
}}
 variant="contained" className="frmPrimarybtn" size="small" onClick={() => this.CustomerAddbox(null)}  startIcon={<AddIcon />}>Add</Button>
        </Box>

<Box
  sx={{
    display: "flex",
    gap: 2,
    mb: 3,
    flexWrap: "wrap",
    alignItems: "center"
  }}
>
  <Box className="contentSearch" sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
    <Typography variant="body1">Name / Email / Mobile</Typography>
   <TextField
    size="small"
    placeholder="Search"
    value={this.state.searchText}
    onChange={(e) => this.setState({ searchText: e.target.value })}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <img
            src={searchIcon} 
            alt="Search"           
          />
        </InputAdornment>
      ),
    }}
  />
  </Box>

<Box sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
  <Typography variant="body1">Role</Typography>

  <FormControl fullWidth size="small">
    <Select
      value={this.state.searchRole}
displayEmpty	  
      onChange={(e) => this.setState({ searchRole: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="1">Admin</MenuItem>
      <MenuItem value="2">Service Staff</MenuItem>
      <MenuItem value="3">Inspection Staff</MenuItem>
    </Select>
  </FormControl>
</Box>

<Box sx={{ display: "flex", flexDirection: "column", width: "230px"}}>
  <Typography variant="body1">Status</Typography>

  <FormControl fullWidth size="small">
    <Select
	displayEmpty
      value={this.state.searchStatus}
      onChange={(e) => this.setState({ searchStatus: e.target.value })}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="0">Active</MenuItem>
      <MenuItem value="1">Inactive</MenuItem>
    </Select>
  </FormControl>
</Box>

  <Button
    variant="contained"
    className="frmPrimarybtn" size="small"    
    onClick={() => this.setState({ page: 0 }, this.fetchCustomer)}
	sx={{marginTop:3}}
  >
    Search
  </Button>
</Box>

        <StaffDialog ref={this.staffDialogRef} onSuccess={this.fetchCustomer} />

      
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>First Week Off</TableCell>
                <TableCell>Second Week Off</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.CustData.map((customer, idx) => (
                <TableRow key={idx}>
                  <TableCell>{customer.cu_name}</TableCell>
                  <TableCell>{customer.cu_emailid}</TableCell>
                  <TableCell>{customer.cu_phonenumber}</TableCell>
                  <TableCell>{customer.cu_role_label}</TableCell>
                  <TableCell>{customer.cu_firstweekoff_label}</TableCell>
                  <TableCell>{customer.cu_secondweekoff_label}</TableCell>
                  <TableCell>
			{customer.cu_role === 1 ? (
  <Button
    variant="contained"
    className="frmPrimarybtn"
    size="small"
    onClick={() => this.CustomerAddbox(customer)}
    endIcon={<EditIcon />}
  >
    Edit
  </Button>
) : (
  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
    <Button
      variant="contained"
      size="small"
      onClick={() =>
        this.toggleActiveStatus(
          customer.cu_id,
          customer.cu_isactive === 0 ? 1 : 0
        )
      }
      className="frmPrimarybtn"
      endIcon={
        customer.cu_isactive === 0
          ? <PersonIcon />
          : <PersonOffIcon />
      }
    >
      {customer.cu_isactive === 0 ? 'Block' : 'Unblock'}
    </Button>

    <Button
      variant="contained"
      className="frmPrimarybtn"
      size="small"
      onClick={() => this.CustomerAddbox(customer)}
      endIcon={<EditIcon />}
    >
      Edit
    </Button>

    <Button
      variant="contained"
      className="frmSecondarybtn"
      size="small"
      onClick={() => this.handleDelete(customer.cu_id)}
      endIcon={<DeleteIcon />}
    >
      Delete
    </Button>
  </div>
)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
		   <TablePagination
            component="div"
            count={this.state.totalItems}
            page={this.state.page}
            onPageChange={this.handleChangePage}
            rowsPerPage={this.state.rowsPerPage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
            rowsPerPageOptions={this.state.itemsPerPageOptions}
          />
        </TableContainer></div>
      </>
    );
  }
}


class StaffDialog extends Component {
  constructor(props) {
    super(props);
	this.dialogContentRef = React.createRef();
    this.state = {
      open: false,
      cu_id: "",showPassword: false,
      cu_name: "",
      cu_emailid: "",
      cu_phonenumber: "",
      cu_password: "",
      cu_role: "",
      cu_firstweekoff: "",
      cu_secondweekoff: "",
      errormessage: "",
      erropen: false,
    };
  }
handleClickOpen = (staff) => {
  if (!staff) {
   
    this.setState({
      cu_id: null,
      cu_name: "",
      cu_emailid: "",
      cu_phonenumber: "",
      cu_password: "", 
      cu_role: "",
      cu_firstweekoff: "",
      cu_secondweekoff: "",
      errormessage: "",
      erropen: false,
      open: true,
    });
  } else {
    this.setState({
      cu_id: staff.cu_id,
      cu_name: staff.cu_name,
      cu_emailid: staff.cu_emailid,
      cu_phonenumber: staff.cu_phonenumber,
      cu_password: "", 
      cu_role: staff.cu_role,
      cu_firstweekoff: staff.cu_firstweekoff,
      cu_secondweekoff: staff.cu_secondweekoff,
      errormessage: "",
      erropen: false,
      open: true,
    });
  }
};




  handleClose = () => this.setState({ open: false });

   handleInput = (event) => {
    const { name, value } = event.target;
	
	if (name === 'cu_phonenumber') {
      const onlyNums = value.replace(/\D/g, '');
      this.setState({ [name]: onlyNums });
      return;
    }
	
    const newValue = name === 'cu_isactive' ? parseInt(value) : value;
    this.setState({ [name]: newValue });
  };

showError = (msg) => {
  this.setState({ errormessage: msg, erropen: true }, () => {
    if (this.dialogContentRef.current) {
      this.dialogContentRef.current.scrollTop = 0;   
    }
  });
};

  validateForm = () => {
    const { cu_name, cu_emailid, cu_phonenumber, cu_password, cu_role, cu_firstweekoff, cu_secondweekoff, cu_id } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!cu_name.trim()) return this.showError("Name is required");
    if (!cu_emailid.trim()) return this.showError("Email is required");
    if (!emailRegex.test(cu_emailid)) return this.showError("Invalid Email");
    if (!/^\d{10}$/.test(cu_phonenumber)) return this.showError("Phone must be 10 digits");
    if (!cu_id && !cu_password.trim()) return this.showError("Password is required for new user");
    if (!cu_role) return this.showError("Role is required");
    if (cu_firstweekoff === "") return this.showError("Select first week off");
    if (cu_secondweekoff === "") return this.showError("Select second week off");
    return true;
  };

handleSubmit = () => {
  if (!this.validateForm()) return;

  const { cu_id, cu_name, cu_emailid, cu_phonenumber, cu_password, cu_role, cu_firstweekoff, cu_secondweekoff } = this.state;
  
  const payload = {
    cu_name,
    cu_emailid,
    cu_phonenumber,
    cu_role,
    cu_firstweekoff,
    cu_secondweekoff,
  };

  if (cu_password.trim() !== "") {
    payload.cu_password = cu_password;
  }

  const request = cu_id
    ? axios.put(`${Serverurl}customer/customerupdate/${cu_id}`, payload)
    : axios.post(`${Serverurl}customer/customerinsert`, payload);

  request
    .then(() => {
      this.handleClose();
      this.props.onSuccess();
    })
    .catch((err) => {
      const msg = err.response?.data?.error || "Something went wrong";
      this.showError(msg);   
    });
};

togglePasswordVisibility = () => {
  this.setState({ showPassword: !this.state.showPassword });
};

  render() {
    return (
      <Dialog open={this.state.open} onClose={this.handleClose} fullWidth>
        <DialogTitle>Staff</DialogTitle>
        <DialogContent  ref={this.dialogContentRef}>
          <Collapse in={this.state.erropen}>
            <Alert severity="error" action={<IconButton onClick={() => this.setState({ erropen: false })}><CloseIcon /></IconButton>}>
              {this.state.errormessage}
            </Alert>
          </Collapse>

          <p>Name<span className="validation"> * </span></p>
          <TextField placeholder="Enter Name" size="small" fullWidth  inputProps={{ maxLength: 150 }} name="cu_name" value={this.state.cu_name} onChange={this.handleInput} />
          <p>Email<span className="validation"> * </span></p>
          <TextField placeholder="Enter Email" size="small" fullWidth name="cu_emailid"  inputProps={{ maxLength: 150 }} value={this.state.cu_emailid} onChange={this.handleInput} />
          <p>Phone Number<span className="validation"> * </span></p>
         <TextField size="small" placeholder="Enter Phone" fullWidth name="cu_phonenumber"  inputProps={{ maxLength: 10 }} value={this.state.cu_phonenumber} onChange={this.handleInput} />
		 <p>Password<span className="validation"> * </span></p>
<TextField
  fullWidth
  size="small"
  type={this.state.showPassword ? "text" : "password"}
  name="cu_password"
  inputProps={{ maxLength: 60 }}
  value={this.state.cu_password}
  onChange={this.handleInput}
  autoComplete="new-password"
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={this.togglePasswordVisibility} size="small" edge="end">
          {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    )
  }}
/>
<p>Role<span className="validation"> * </span></p>
          <FormControl fullWidth>
            <Select native size="small" name="cu_role" value={this.state.cu_role} onChange={this.handleInput}>
              <option value="">Select Role</option>
              <option value="1">Admin</option>
              <option value="2">Service Staff</option>
              <option value="3">Inspection Staff</option>
            </Select>
          </FormControl>
          <p>First Week Off</p>
          <FormControl fullWidth>
            <Select size="small" native name="cu_firstweekoff" value={this.state.cu_firstweekoff} onChange={this.handleInput}>
              <option value="">Select First Week Off</option>
              <option value="0">Sunday</option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
            </Select>
          </FormControl>
          <p>Second Week Off</p>
          <FormControl fullWidth>
            <Select size="small" native name="cu_secondweekoff" value={this.state.cu_secondweekoff} onChange={this.handleInput}>
              <option value="">Select Second Week Off</option>
              <option value="0">Sunday</option>
              <option value="1">Monday</option>
              <option value="2">Tuesday</option>
              <option value="3">Wednesday</option>
              <option value="4">Thursday</option>
              <option value="5">Friday</option>
              <option value="6">Saturday</option>
            </Select>
          </FormControl>
        </DialogContent>
       <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
  <Button variant="contained" className="frmSecondarybtn" size="large" onClick={this.handleClose}>
    Cancel
  </Button>

  <Button variant="contained" className="frmPrimarybtn" size="large" onClick={this.handleSubmit}>
    Save
  </Button>
</DialogActions>
      </Dialog>
    );
  }
}
